import { getType } from 'typesafe-actions';

import { setErrorFallbackPageData, clearErrorFallbackPageData } from '../actions/errorFallbackPage.actions';

import { ErrorFallbackPageState } from './types';
import { RootAction } from '../actions/types';

const initialState: ErrorFallbackPageState = {
  errorMessage: null,
  showIcon: false,
  iconType: null,
  buttonText: null,
};

export default (state: ErrorFallbackPageState = initialState, action: RootAction): ErrorFallbackPageState => {
  switch (action.type) {
    case getType(setErrorFallbackPageData): {
      return {
        errorMessage: action.payload.errorMessage || null,
        showIcon: action.payload.showIcon || false,
        iconType: action.payload.iconType || null,
        buttonText: action.payload.buttonText || null,
      };
    }
    case getType(clearErrorFallbackPageData): {
      return initialState;
    }
    default: {
      return state;
    }
  }
};
